import { render, staticRenderFns } from "./SearchExpenses.vue?vue&type=template&id=e70129d0&scoped=true"
import script from "./SearchExpenses.vue?vue&type=script&lang=js"
export * from "./SearchExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70129d0",
  null
  
)

export default component.exports